import News from './NewsPage';

export default News;
